import Joi from '@hapi/joi';
import { Profil } from 'types';
import validate from './validate';

export const schema = Joi.object<Partial<Profil>>({
  name: Joi.string().max(255).required().messages({
    'string.max': 'STRING_MAX',
    'string.empty': 'REQUIRED_FIELD',
  }),
});

export default () => (value: Partial<Profil>) => {
  return validate(schema, value, {
    allowUnknown: true,
    context: {},
  });
};
